<template>
  <div class="page-wrap">
    <div class="panel-card">

      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-map-marker"></i></div>
          <div>
            <div class="panel-title">{{ pageTitle }}</div>
            <div class="panel-sub">{{ pageSub }}</div>
          </div>
        </div>
      </div>

      <div class="tab-bar" v-if="currentUser.u.is_admin == 0">
        <button class="tab-btn" :class="{ active: active_tab === 'map' }" @click="active_tab = 'map'">
          <i class="fa fa-map"></i> Map
        </button>
        <button class="tab-btn" :class="{ active: active_tab === 'sms' }" @click="active_tab = 'sms'">
          <i class="fa fa-comment"></i> SMS
        </button>
      </div>

      <div class="tab-body">
        <v-map v-if="active_tab === 'map'" />
        <v-sms v-if="active_tab === 'sms'" />
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import vMap from "@/pages/backend/settings/map_n_sms_config/map";
import vSms from "@/pages/backend/settings/map_n_sms_config/sms";

export default {
  components: { vMap, vSms },
  data() {
    return {
      active_tab: "map",
      pageTitle: "Map & SMS Configuration",
      pageSub: "Google Maps API key, search radius and SMS provider settings",
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "" },
        { id: 2, title: "Setting",   route: "" },
        { id: 3, title: "Map & SMS Config", route: "" }
      ]
    };
  },
  computed: { ...mapGetters(["currentUser"]) },
  created() {
    if (this.$route.name === "client.map_config") {
      this.breadCrumbs[0].route = "admin.dashboard";
      this.breadCrumbs[2].title = "Map Config";
      this.pageTitle = "Map Configuration";
      this.pageSub   = "Google Maps API key and search radius settings";
      this.active_tab = "map";
    } else {
      this.breadCrumbs[0].route = "client.dashboard";
    }
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;

.page-wrap {
  padding: 24px;
  font-family: $font;
}

.panel-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13,27,62,0.08);
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 20px 24px 18px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbff;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-icon {
  width: 40px; height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, $blue, #2176ae);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 17px; flex-shrink: 0;
}

.panel-title { font-size: 15px; font-weight: 700; color: $dark; }
.panel-sub   { font-size: 12px; color: #8a94a6; margin-top: 2px; }

.tab-bar {
  display: flex;
  gap: 4px;
  padding: 14px 20px 0;
  border-bottom: 2px solid #f0f3fa;
  background: #fafbff;
}

.tab-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 36px; padding: 0 18px;
  border-radius: 8px 8px 0 0;
  border: 1.5px solid transparent; border-bottom: none;
  background: transparent; color: #6b7280;
  font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; position: relative; bottom: -2px;
  transition: color 0.15s, background 0.15s;
  i { font-size: 12px; }
  &:hover:not(.active) { color: $blue; background: #f0f8fd; }
  &.active { color: $blue; background: #fff; border-color: #f0f3fa; border-bottom-color: #fff; }
}

.tab-body { padding: 28px 32px 32px; max-width: 520px; }
</style>
